import styled from 'styled-components/macro';

export const NavHeadingStyles = styled.div`
  ${({ theme: { spacing } }) => `
    display: flex;
    align-items: center;
    padding: ${spacing?.(2)} ${spacing?.(2)} ${spacing?.(1)} ${spacing?.(2)};

  `}
`;

export const NavHeadingLabelStyles = styled.div`
  ${({ theme: { colors = {}, spacing } }) => `
    width: 100%;
    font-weight: bold;
    padding-bottom: ${spacing?.(1)};
    color: ${colors.grey?.darkest};
    box-shadow: inset 0px -1px 0px ${colors.grey?.light}
  `}
`;
